import type { BreakpointName } from '@noths/polaris-client-ribbons-base';
import { maxBreakpoints, minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing } = theme;

export const item = css`
  padding: 0 ${spacing.xs}px;
  flex: 1 1 0;
  text-align: center;

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      padding: 0;
      width: ${spacing.lg * 4}px;
    `,
  )}
`;

export const getVisibleBelowBreakpointStyles = (breakpoint?: BreakpointName) => {
  return breakpoint
    ? css`
        ${mediaQuery(
          { min: minBreakpoints[breakpoint] },
          css`
            display: none;
          `,
        )}
      `
    : '';
};

export const getVisibleAboveBreakpointStyles = (breakpoint?: BreakpointName) => {
  return breakpoint
    ? css`
        ${mediaQuery(
          { max: maxBreakpoints[breakpoint] },
          css`
            display: none;
          `,
        )}
      `
    : '';
};

export const label = css`
  display: none;

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      display: block;
    `,
  )}
`;
